import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { X, Tag, ArrowRight } from "lucide-react";

const KEY = "be_coupon_popup_shown";

/** Delayed limited-time coupon popup — shown after 25s on first qualifying page. */
export default function CouponPopup() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    if (pathname.startsWith("/admin") || pathname.startsWith("/practice/") || pathname.startsWith("/checkout") || pathname.startsWith("/login") || pathname.startsWith("/register")) return;
    const t = setTimeout(() => {
      sessionStorage.setItem(KEY, "1");
      setOpen(true);
    }, 25000);
    return () => clearTimeout(t);
  }, [pathname]);

  if (!open) return null;
  return (
    <div className="fixed bottom-5 right-5 z-[90] w-[360px] rounded-2xl border border-border bg-card p-5 shadow-2xl animate-[fadeUp_.3s_ease]" data-testid="coupon-popup">
      <button onClick={() => setOpen(false)} className="absolute top-2.5 right-2.5 rounded-md p-1 hover:bg-accent" aria-label="Close">
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-center gap-2">
        <div className="flex h-9 w-9 items-center justify-center rounded-md bg-[color:var(--brand-amber-soft)]">
          <Tag className="h-4 w-4 text-[color:var(--brand-amber-hover)]" />
        </div>
        <div className="font-display text-base">Limited time</div>
      </div>
      <h3 className="mt-3 font-display text-xl">
        <span className="font-serif text-gradient-gold">50% off</span> all practice tests
      </h3>
      <p className="mt-1 text-xs text-muted-foreground">
        Use <span className="font-mono font-bold text-foreground">LAUNCH50</span> at checkout. Today only.
      </p>
      <Link to="/marketplace" onClick={() => setOpen(false)}>
        <button className="btn-primary mt-4 w-full" data-testid="coupon-popup-cta">
          Browse practice tests <ArrowRight className="h-4 w-4" />
        </button>
      </Link>
    </div>
  );
}
